import React, { forwardRef } from 'react';

const Bookmarked = forwardRef( ( props, ref ) => (
	<svg
		ref={ ref }
		style={ { enableBackground: 'new 0 0 512 512' } }
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 512 512"
		{ ...props }
	>
		<path d="M78.378 0v510.536l183.308-143.085L433.622 512V0z" />
	</svg>
) );

Bookmarked.displayName = 'Bookmarked';

export default Bookmarked;
